import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import _uniqueId from "lodash/uniqueId";
import * as React from 'react';
import classNames from 'classnames';
import Box from "../Box";
import ToggleBoxContext from "./ToggleBoxContext";
var useMemo = React.useMemo;
export var ToggleBox = function ToggleBox(_ref) {
  var _ref$connected = _ref.connected,
      connected = _ref$connected === void 0 ? false : _ref$connected,
      children = _ref.children,
      className = _ref.className,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'horizontal' : _ref$direction,
      id = _ref.id,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? 'inline' : _ref$layout,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? '' : _ref$name,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size;
  var idGenerator = useMemo(function () {
    return id || _uniqueId('ToggleBox-');
  }, [id]);
  var classes = classNames('ToggleBox', {
    'ToggleBox--connected': connected,
    'ToggleBox--direction--horizontal': direction === 'horizontal',
    'ToggleBox--direction--vertical': direction === 'vertical'
  }, className);
  var directionValue = direction === 'horizontal' ? 'row' : 'column';
  var renderableChildren = React.Children.toArray(children);
  var firstChild = 0;
  var lastChild = renderableChildren.length - 1;
  return /*#__PURE__*/React.createElement("fieldset", {
    className: classes,
    id: idGenerator
  }, /*#__PURE__*/React.createElement(Box, {
    flex: {
      alignItems: 'stretch',
      direction: directionValue
    }
  }, React.Children.map(renderableChildren, function (child, i) {
    return /*#__PURE__*/React.createElement(ToggleBoxContext.Provider, {
      value: {
        connected: connected,
        direction: direction,
        isFirst: i === firstChild,
        isLast: i === lastChild,
        layout: layout,
        name: name,
        size: size
      }
    }, child);
  })));
};